import { useLessonPlayer } from '../../hooks/useLessonPlayer.js'
import { FRAMES } from '../../model/frames.js'
import FocusLayout from './FocusLayout.jsx'

export default function FocusIndScreen({ frames = FRAMES } = {}) {
  const player = useLessonPlayer(frames)
  return <FocusLayout theme="industry" {...player} />
}
